var React = require('react');

function CheckThin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"16/check"},React.createElement("path",{"id":"Vector","d":"M5.33325 16.0001L11.9329 22.5998L26.0751 8.45764","stroke":"#59A2FF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

CheckThin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CheckThin;

CheckThin.default = CheckThin;
